/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export enum UserStatusEnum {
  Succursale = "Succursale",
  Franchise = "Franchise",
  Collaborateur = "Collaborateur",
  DDP_AR = "DDP_AR",
  Siege = "Siege",
  Partenaire = "Partenaire",
  Medecin = "Medecin",
  Organisation = "Organisation",
  Autre = "Autre",
}

export enum UserRelationEnum {
  Conjoint = "Conjoint",
  Collaborateur = "Collaborateur",
  Enfant = "Enfant",
  Adulte = "Adulte",
  Autre = "Autre",
}

export enum TravelDbTypeEnum {
  Seminaire = "Seminaire",
  Special = "Special",
  Private = "Private",
  Group = "Group",
  Ski = "Ski",
  Benevolat = "Benevolat",
}

export enum TravelDbTransportationTypeEnum {
  Vol = "Vol",
  Train = "Train",
  Autocar = "Autocar",
}

export enum TravelDbTransferTypeEnum {
  Bus = "Bus",
  Train = "Train",
  Autocar = "Autocar",
}

export enum TravelDbTransferDirectionEnum {
  Outbound = "Outbound",
  Return = "Return",
  RoundTrip = "RoundTrip",
}

export enum TravelDbTitleBannerAlignmentEnum {
  Center = "Center",
  Left = "Left",
  Right = "Right",
}

export enum TravelDbHotelRoomTypeEnum {
  Single = "Single",
  Double = "Double",
  Twin = "Twin",
  Famille = "Famille",
}

export enum TravelDbFieldTypeEnum {
  Text = "Text",
  TextArea = "TextArea",
  Choice = "Choice",
  Number = "Number",
  Date = "Date",
  Boolean = "Boolean",
}

export enum TravelDbDocumentTypeEnum {
  Image = "Image",
  Pdf = "Pdf",
  Any = "Any",
}

export enum TravelDbDiscountTypeEnum {
  Euro = "Euro",
  Percent = "Percent",
}

export enum SettingKeyEnum {
  MODE_BETA = "MODE_BETA",
}

export enum PaymentStatusEnum {
  Pending = "Pending",
  Processing = "Processing",
  Succeeded = "Succeeded",
  Failed = "Failed",
  Canceled = "Canceled",
}

export enum CivilityEnum {
  Mr = "Mr",
  Mrs = "Mrs",
}

export enum BannerLinkTypeEnum {
  None = "None",
  Link = "Link",
  Vimeo = "Vimeo",
}

export interface AdminBanner {
  /** @format int32 */
  id: number;
  text: string;
  linkType?: BannerLinkTypeEnum;
  link?: null | string;
  videoKey?: null | string;
  videoTitle?: null | string;
  /** @format int32 */
  travelId: number;
  travelName: string;
  visible?: boolean;
}

export interface AdminBannerRequest {
  /** @format int32 */
  id?: number;
  /** @format int32 */
  travelId: number;
  visible?: boolean;
  text: string;
  linkType?: BannerLinkTypeEnum;
  link?: null | string;
  videoKey?: null | string;
  videoTitle?: null | string;
}

export interface AdminTravel {
  /** @format int32 */
  id: number;
  emailContact: string;
  /** @format int32 */
  invitationTemplateId: number;
  /** @format int32 */
  confirmationTemplateId: number;
  /** @format int32 */
  optoutTemplateId?: null | number;
  /** @format int32 */
  webInscriptionTemplateId?: null | number;
  /** @format int32 */
  reminderTemplateId?: null | number;
  /** @format date-time */
  deletedDate?: null | Date;
  name: string;
  slug?: null | string;
  type: TravelDbTypeEnum;
  company?: null | string;
  /** @format int32 */
  nights: number;
  /** @format int32 */
  organisationMemberCount?: number;
  /** @format date-time */
  startDate: Date;
  /** @format date-time */
  endDate: Date;
  /** @format date-time */
  registrationStartDate: Date;
  /** @format date-time */
  registrationEndDate: Date;
  priceTTC: boolean;
  /** @format int32 */
  nemoCost: number;
  /** @format int32 */
  accommodationCost: number;
  /** @format int32 */
  transportCost: number;
  /** @format int32 */
  childPackageCost?: null | number;
  packageMandatory: boolean;
  paymentEnabled: boolean;
  birthDateRequired: boolean;
  passeportRequired: boolean;
  passeportSixMonthsRequired?: null | boolean;
  estaRequired: boolean;
  userStatusRequired: boolean;
  usersStatusAvailable?: null | UserStatusEnum[];
  invoiceEnabled: boolean;
  companionsEnabled: boolean;
  nationalityRequired: boolean;
  addressRequired: boolean;
  emergencyContactRequested: boolean;
  refusalLabel?: null | string;
  refusalLongLabel?: null | string;
  buttonPackageSelectionLabel?: null | string;
  companionLabel?: null | string;
  transportations?: TravelDbTransportation[];
  transfers?: TravelDbTransfer[];
  hotels?: TravelDbHotel[];
  options?: TravelDbOption[];
  infoFields?: TravelDbInfoField[];
  documents?: TravelDbDocument[];
  pages?: TravelDbPage[];
  /** @format int32 */
  mainPictureId?: null | number;
  mainPicture?: FileDb;
  /** @format int32 */
  titleBannerId?: null | number;
  titleBanner?: FileDb;
  titleBannerAlignment?: TravelDbTitleBannerAlignmentEnum;
  /** @format int32 */
  logoId?: null | number;
  logo?: FileDb;
  /** @format int32 */
  logoCompactId?: null | number;
  logoCompact?: FileDb;
  /** @format int32 */
  bannerId?: null | number;
  banner?: FileDb;
  /** @format int32 */
  roadBookId?: null | number;
  roadBook?: FileDb;
  firmaTemplateId?: null | string;
  isoCode?: null | string;
  canRefuse: boolean;
  needRefusalReason?: null | boolean;
  refusalReasons?: null | string[];
  refusalReasons2?: null | string[];
  participations?: null | ParticipationDb[];
  banners?: BannerDb[];
  messages?: TravelDbMessages;
}

export interface AdminTravelBasic {
  /** @format int32 */
  id: number;
  name: string;
  slug?: null | string;
  type: TravelDbTypeEnum;
  company?: null | string;
  /** @format date-time */
  startDate: Date;
  /** @format date-time */
  endDate: Date;
  /** @format date-time */
  registrationStartDate: Date;
  /** @format date-time */
  registrationEndDate: Date;
  isoCode?: null | string;
}

export interface AdminTravelBasicItemList {
  items: AdminTravelBasic[];
  /** @format int32 */
  page: number;
  /** @format int32 */
  pageSize: number;
  /** @format int32 */
  totalItems: number;
}

export interface AdminUser {
  /** @format int32 */
  id: number;
  encryptedPassword?: null | string;
  encryptedLoginCode?: null | string;
  /** @format date-time */
  loginCodeExpirationDate?: null | Date;
  isAdmin?: boolean;
  civility?: CivilityEnum;
  status?: UserStatusEnum;
  firstName?: string;
  lastName?: string;
  email?: null | string;
  mobilePhone?: null | string;
  address?: null | string;
  city?: null | string;
  postalCode?: null | string;
  company?: null | string;
  /** @format date-time */
  birthDate?: null | Date;
  nationality?: null | string;
  passportNumber?: null | string;
  /** @format date-time */
  passportExpirationDate?: null | Date;
  /** @format date-time */
  deletedDate?: null | Date;
  /** @format date-time */
  lastUpdateDate?: Date;
  participationsBasic?: null | AdminUserParticipationBasic[];
  password?: null | string;
}

export interface AdminUserItemList {
  items: AdminUser[];
  /** @format int32 */
  page: number;
  /** @format int32 */
  pageSize: number;
  /** @format int32 */
  totalItems: number;
}

export interface AdminUserParticipationBasic {
  /** @format int32 */
  travelId?: number;
  travelName?: null | string;
  /** @format date-time */
  travelStartDate?: Date;
  /** @format date-time */
  travelEndDate?: Date;
}

export interface BannerDb {
  /** @format int32 */
  id: number;
  /** @format int32 */
  travelDbId: number;
  visible?: boolean;
  text: string;
  linkType?: BannerLinkTypeEnum;
  link?: null | string;
  videoKey?: null | string;
  videoTitle?: null | string;
}

export interface BoardTravel {
  /** @format int32 */
  id: number;
  /** @format int32 */
  travelId: number;
}

export interface CheckEmailResponse {
  exists?: boolean;
  isDeleted?: boolean;
  user?: AdminUser;
}

export interface FileDb {
  /** @format int32 */
  id: number;
  /** @format uuid */
  key: string;
  mimeType: string;
  base64Content?: null | string;
}

export interface ImportParticipantsResult {
  /** @format int32 */
  added?: number;
  /** @format int32 */
  created?: number;
  /** @format int32 */
  alreadyPresent?: number;
  /** @format int32 */
  errors?: number;
  errorMessages?: string[];
}

export interface InvitationValidationResponse {
  user: UserMe;
  /** @format int32 */
  travelId: number;
}

export interface ParticipantBasic {
  /** @format int32 */
  id: number;
  firstName: string;
  lastName: string;
}

export interface ParticipationDb {
  /** @format int32 */
  id: number;
  /** @format int32 */
  travelDbId: number;
  /** @format int32 */
  userDbId: number;
  user?: UserDb;
  userInfo?: ParticipationDbUserInfo;
  userEmail?: null | string;
  userLastName?: string;
  userFirstName?: string;
  userFullName?: string;
  travelInfo?: ParticipationDbTravelInfo;
  invoice?: ParticipationDbInvoice;
  companions?: ParticipationDbCompanion[];
  invitation?: ParticipationDbInvitation;
  transportation?: ParticipationDbTransportation;
  transfer?: ParticipationDbTransfer;
  hotelRooms?: ParticipationDbHotelRoom[];
  activities?: ParticipationDbActivity[];
  documents?: ParticipationDbDocument[];
  admin?: ParticipationDbAdmin;
  signature?: ParticipationDbSignature;
  consolidate_Answered?: boolean;
  consolidate_Present?: null | boolean;
  consolidate_WithoutTransport?: null | boolean;
  /** @format date-time */
  consolidate_StartDate?: null | Date;
  /** @format date-time */
  consolidate_EndDate?: null | Date;
  payments?: ParticipationDbPayment[];
}

export interface ParticipationDbActivity {
  /** @format int32 */
  participantCount?: number;
  /** @format int32 */
  travelDbOptionActivityId: number;
  /** @format int32 */
  participationDbId: number;
}

export interface ParticipationDbAdmin {
  /** @format int32 */
  discount?: number;
  discountType?: TravelDbDiscountTypeEnum;
  discountLabel?: null | string;
  notes?: null | string;
  /** @format int32 */
  participationDbId: number;
}

export interface ParticipationDbCompanion {
  /** @format int32 */
  id?: number;
  civility?: CivilityEnum;
  status?: UserStatusEnum;
  firstName?: null | string;
  lastName?: null | string;
  email?: null | string;
  mobilePhone?: null | string;
  address?: null | string;
  city?: null | string;
  postalCode?: null | string;
  company?: null | string;
  /** @format date-time */
  birthDate?: null | Date;
  nationality?: null | string;
  passportNumber?: null | string;
  /** @format date-time */
  passportExpirationDate?: null | Date;
  estaNumber?: null | string;
  infoFields?: ParticipationDbCompanionInfoField[];
  documents?: ParticipationDbCompanionDocument[];
  relation?: UserRelationEnum;
  /** @format int32 */
  participationDbId: number;
}

export interface ParticipationDbCompanionDocument {
  /** @format int32 */
  fileId?: null | number;
  file?: FileDb;
  /** @format int32 */
  travelDbDocumentId: number;
  /** @format int32 */
  participationDbCompanionId: number;
}

export interface ParticipationDbCompanionInfoField {
  value?: null | string;
  /** @format int32 */
  travelDbInfoFieldId: number;
  /** @format int32 */
  participationDbCompanionId: number;
}

export interface ParticipationDbDocument {
  /** @format int32 */
  fileId?: null | number;
  file?: FileDb;
  /** @format int32 */
  travelDbDocumentId: number;
  /** @format int32 */
  participationDbId: number;
}

export interface ParticipationDbHotelRoom {
  /** @format int32 */
  id?: number;
  /** @format int32 */
  rank?: null | number;
  type: TravelDbHotelRoomTypeEnum;
  roommates?: ParticipationDbHotelRoommate[];
  /** @format int32 */
  travelDbHotelRoomId: number;
  /** @format int32 */
  participationDbId: number;
}

export interface ParticipationDbHotelRoommate {
  /** @format int32 */
  id?: number;
  /** @format int32 */
  userDbId?: null | number;
  /** @format int32 */
  participationDbCompanionId?: null | number;
  /** @format int32 */
  participationDbHotelRoomId: number;
}

export interface ParticipationDbInvitation {
  /** @format date-time */
  sentDate?: null | Date;
  /** @format date-time */
  reminderSentDate?: null | Date;
  /** @format date-time */
  lastUpdateDate?: null | Date;
  /** @format date-time */
  completionDate?: null | Date;
  /** @format date-time */
  refusalDate?: null | Date;
  refusalReason?: null | string;
  /** @format int32 */
  participationDbId: number;
}

export interface ParticipationDbInvoice {
  company?: null | string;
  shopCode?: null | string;
  lastName?: null | string;
  firstName?: null | string;
  address?: null | string;
  zipCode?: null | string;
  city?: null | string;
  country?: null | string;
  /** @format int32 */
  participationDbId: number;
}

export interface ParticipationDbPayment {
  /** @format int32 */
  id?: number;
  /** @format int32 */
  participationDbId: number;
  paymentIntentId: string;
  /** @format int64 */
  amountInCents: number;
  status?: PaymentStatusEnum;
  /** @format date-time */
  createdDate?: Date;
  /** @format date-time */
  lastUpdatedDate?: Date;
  /** @format date-time */
  succeededDate?: null | Date;
  /** @format date-time */
  failedDate?: null | Date;
  /** @format date-time */
  canceledDate?: null | Date;
  failureReason?: null | string;
  lastStripeEventId?: null | string;
}

export interface ParticipationDbSignature {
  /** @format int32 */
  participationDbId: number;
  firmaSigningRequestId: string;
  firmaSigningUserId: string;
  /** @format date-time */
  signedDate?: null | Date;
  /** @format int32 */
  signedDocumentFileId?: null | number;
  signedDocument?: FileDb;
}

export interface ParticipationDbTransfer {
  /** @format int32 */
  outboundTravelDbTransferId?: null | number;
  /** @format int32 */
  returnTravelDbTransferId?: null | number;
  /** @format int32 */
  roundTripTravelDbTransferId?: null | number;
  /** @format int32 */
  participationDbId: number;
}

export interface ParticipationDbTransportation {
  /** @format int32 */
  travelDbTransportationId?: null | number;
  /** @format int32 */
  optionId?: null | number;
  /** @format date-time */
  customStartDate?: null | Date;
  /** @format date-time */
  customEndDate?: null | Date;
  outboundCompany?: null | string;
  outboundAirport?: null | string;
  outboundAirportLastStop?: null | string;
  /** @format date-time */
  outboundDate?: null | Date;
  /** @format date-span */
  outboundTime?: null | string;
  outboundFlightNumber?: null | string;
  returnCompany?: null | string;
  returnAirport?: null | string;
  returnAirportLastStop?: null | string;
  /** @format date-time */
  returnDate?: null | Date;
  /** @format date-span */
  returnTime?: null | string;
  returnFlightNumber?: null | string;
  /** @format int32 */
  participationDbId: number;
}

export interface ParticipationDbTravelInfo {
  withPackage?: boolean;
  withoutTransport?: boolean;
  specialCase?: boolean;
  /** @format date-time */
  customStartDate?: null | Date;
  /** @format date-time */
  customEndDate?: null | Date;
  /** @format int32 */
  participationDbId: number;
}

export interface ParticipationDbUserInfo {
  civility?: CivilityEnum;
  status?: UserStatusEnum;
  firstName?: null | string;
  lastName?: null | string;
  email?: null | string;
  mobilePhone?: null | string;
  address?: null | string;
  city?: null | string;
  postalCode?: null | string;
  company?: null | string;
  /** @format date-time */
  birthDate?: null | Date;
  nationality?: null | string;
  passportNumber?: null | string;
  /** @format date-time */
  passportExpirationDate?: null | Date;
  estaNumber?: null | string;
  specialRequests?: null | string;
  allergies?: null | string;
  emergencyContactFirstname?: null | string;
  emergencyContactLastname?: null | string;
  emergencyContactEmail?: null | string;
  emergencyContactPhone?: null | string;
  infoFields?: ParticipationDbUserInfoField[];
  /** @format int32 */
  participationDbId: number;
}

export interface ParticipationDbUserInfoField {
  value?: null | string;
  /** @format int32 */
  travelDbInfoFieldId: number;
  /** @format int32 */
  participationDbUserInfoId: number;
}

export interface PaymentIntentResponse {
  clientSecret: string;
  /** @format int64 */
  amountInCents: number;
  currency: string;
  status: PaymentStatusEnum;
}

export interface RemoveParticipantsRequest {
  userIds: number[];
}

export interface SendInvitationsRequest {
  userIds: number[];
}

export interface EmailTemplateDto {
  /** @format int64 */
  id: number;
  name: string;
  subject?: null | string;
}

export interface SendParticipantsEmailRequest {
  /** @format int64 */
  templateId: number;
  userIds: number[];
}

export interface SendParticipantsEmailResult {
  /** @format int32 */
  sent: number;
}

export interface TravelBrandingDto {
  /** @format uuid */
  logoKey?: null | string;
}

export interface TravelDbDocument {
  /** @format int32 */
  id: number;
  /** @format int32 */
  rank?: number;
  type: TravelDbDocumentTypeEnum;
  label: string;
  subTitle?: null | string;
  required: boolean;
  alsoForCompanion?: boolean;
  instructions?: null | string;
}

export interface TravelDbHotel {
  /** @format int32 */
  id: number;
  /** @format int32 */
  rank?: number;
  name: string;
  /** @format int32 */
  nights: number;
  /** @format int32 */
  pictureId?: null | number;
  picture?: FileDb;
  quotaGroups?: TravelDbHotelQuotaGroup[];
}

export interface TravelDbHotelQuotaGroup {
  /** @format int32 */
  id: number;
  /** @format int32 */
  quota: number;
  onRequest?: boolean;
  rooms?: TravelDbHotelRoom[];
}

export interface TravelDbHotelRoom {
  /** @format int32 */
  id: number;
  /** @format int32 */
  rank?: number;
  name: string;
  type: TravelDbHotelRoomTypeEnum;
  /** @format int32 */
  price: number;
  /** @format int32 */
  pictureId?: null | number;
  picture?: FileDb;
}

export interface TravelDbInfoField {
  /** @format int32 */
  id: number;
  /** @format int32 */
  rank?: number;
  type: TravelDbFieldTypeEnum;
  label: string;
  required: boolean;
  alsoForCompanion?: boolean;
  choices?: null | string[];
}

export interface TravelDbMessages {
  /** @format int32 */
  id?: number;
  pageInformations?: null | string;
  pageInvoice?: null | string;
  pageCompanions?: null | string;
  pageTransports?: null | string;
  pageTransfers?: null | string;
  pageHotels?: null | string;
  pageOptions?: null | string;
  pageDocuments?: null | string;
  pageRequests?: null | string;
  pagePayment?: null | string;
  pageSummary?: null | string;
}

export interface TravelDbOption {
  /** @format int32 */
  id: number;
  /** @format int32 */
  rank?: number;
  name: string;
  link?: null | string;
  linkLabel?: null | string;
  linkText?: null | string;
  /** @format int32 */
  pictureId?: null | number;
  picture?: FileDb;
  activities?: TravelDbOptionActivity[];
}

export interface TravelDbOptionActivity {
  /** @format int32 */
  id: number;
  /** @format int32 */
  rank?: number;
  name: string;
  /** @format int32 */
  price: number;
  noPrice: boolean;
  description?: null | string;
  /** @format int32 */
  pictureId?: null | number;
  picture?: FileDb;
  details?: null | string;
}

export interface TravelDbPage {
  /** @format int32 */
  id: number;
  title: string;
  labelIcon?: null | string;
  content: string;
  hideDuringInscription: boolean;
}

export interface TravelDbTransfer {
  /** @format int32 */
  id: number;
  /** @format int32 */
  rank?: number;
  direction: TravelDbTransferDirectionEnum;
  type: TravelDbTransferTypeEnum;
  name: string;
  /** @format int32 */
  quota: number;
  meetingPoint?: null | string;
  /** @format date-time */
  startDate?: null | Date;
  details?: null | string;
}

export interface TravelDbTransportation {
  /** @format int32 */
  id: number;
  /** @format int32 */
  rank?: number;
  type: TravelDbTransportationTypeEnum;
  name: string;
  /** @format int32 */
  extraDays: number;
  outboundCompany?: null | string;
  outboundItinerary?: null | string;
  outboundDate?: null | string;
  returnCompany?: null | string;
  returnItinerary?: null | string;
  returnDate?: null | string;
  options?: TravelDbTransportationOption[];
}

export interface TravelDbTransportationOption {
  /** @format int32 */
  id: number;
  /** @format int32 */
  rank?: number;
  name: string;
  /** @format int32 */
  price: number;
  /** @format int32 */
  quota: number;
}

export interface UserBanner {
  /** @format int32 */
  id: number;
  text: string;
  linkType?: BannerLinkTypeEnum;
  link?: null | string;
  videoKey?: null | string;
  videoTitle?: null | string;
}

export interface UserDb {
  /** @format int32 */
  id: number;
  encryptedPassword?: null | string;
  encryptedLoginCode?: null | string;
  /** @format date-time */
  loginCodeExpirationDate?: null | Date;
  isAdmin?: boolean;
  civility?: CivilityEnum;
  status?: UserStatusEnum;
  firstName?: string;
  lastName?: string;
  email?: null | string;
  mobilePhone?: null | string;
  address?: null | string;
  city?: null | string;
  postalCode?: null | string;
  company?: null | string;
  /** @format date-time */
  birthDate?: null | Date;
  nationality?: null | string;
  passportNumber?: null | string;
  /** @format date-time */
  passportExpirationDate?: null | Date;
  /** @format date-time */
  deletedDate?: null | Date;
  /** @format date-time */
  lastUpdateDate?: Date;
}

export interface UserDocumentInstruction {
  /** @format int32 */
  documentId: number;
  instruction: string;
}

export interface UserFile {
  /** @format uuid */
  key: string;
  mimeType: string;
  base64Content?: null | string;
}

export interface UserHotel {
  /** @format int32 */
  id: number;
  /** @format int32 */
  rank?: number;
  name: string;
  /** @format int32 */
  nights: number;
  picture?: UserFile;
  rooms?: UserHotelRoom[];
}

export interface UserHotelRoom {
  /** @format int32 */
  id?: number;
  /** @format int32 */
  rank?: number;
  name: string;
  type: TravelDbHotelRoomTypeEnum;
  /** @format int32 */
  price: number;
  picture?: UserFile;
  /** @format int32 */
  quotaLeft?: null | number;
  onRequest?: boolean;
}

export interface UserMe {
  /** @format int32 */
  id?: number;
  environment?: null | string;
  password?: null | string;
  isAdmin?: boolean;
  firstName: string;
  lastName: string;
  email?: null | string;
  mobilePhone?: null | string;
  address?: null | string;
  city?: null | string;
  postalCode?: null | string;
  civility?: CivilityEnum;
  status?: UserStatusEnum;
  company?: null | string;
  /** @format date-time */
  birthDate?: null | Date;
  nationality?: null | string;
  passportNumber?: null | string;
  /** @format date-time */
  passportExpirationDate?: null | Date;
}

export interface UserOption {
  /** @format int32 */
  id: number;
  /** @format int32 */
  rank?: number;
  name: string;
  link?: null | string;
  linkLabel?: null | string;
  linkText?: null | string;
  picture?: UserFile;
  activities?: UserOptionActivity[];
}

export interface UserOptionActivity {
  /** @format int32 */
  id: number;
  /** @format int32 */
  rank?: number;
  name: string;
  /** @format int32 */
  price: number;
  noPrice: boolean;
  description?: null | string;
  details?: null | string;
  picture?: UserFile;
}

export interface UserParticipation {
  travelInfo: UserParticipationTravelInfo;
  userInfo: UserParticipationUserInfo;
  travel: UserTravel;
  invoice?: UserParticipationInvoice;
  companions?: UserParticipationCompanion[];
  invitation?: UserParticipationInvitation;
  transportation?: UserParticipationTransportation;
  transfer?: UserParticipationTransfer;
  hotelRooms?: UserParticipationHotelRoom[];
  options?: UserParticipationOption[];
  documents?: UserParticipationDocument[];
  cost?: UserParticipationCost;
  admin?: UserParticipationAdmin;
  signature?: UserParticipationSignature;
  payment?: UserParticipationPayment;
}

export interface UserParticipationAdmin {
  /** @format int32 */
  discount?: number;
  discountType?: TravelDbDiscountTypeEnum;
  discountLabel?: null | string;
  notes?: null | string;
}

export interface UserParticipationBasic {
  travel: UserTravel;
  invitation?: UserParticipationInvitation;
}

export interface UserParticipationBasicItemList {
  items: UserParticipationBasic[];
  /** @format int32 */
  page: number;
  /** @format int32 */
  pageSize: number;
  /** @format int32 */
  totalItems: number;
}

export interface UserParticipationCompanion {
  /** @format int32 */
  id?: number;
  civility?: CivilityEnum;
  status?: UserStatusEnum;
  lastName?: null | string;
  firstName?: null | string;
  email?: null | string;
  mobilePhone?: null | string;
  /** @format date-time */
  birthDate?: null | Date;
  nationality?: null | string;
  passportNumber?: null | string;
  /** @format date-time */
  passportExpirationDate?: null | Date;
  estaNumber?: null | string;
  relation?: UserRelationEnum;
  infoFields?: UserParticipationInfoField[];
  documents?: UserParticipationDocument[];
}

export interface UserParticipationCost {
  /** @format int32 */
  package?: number;
  /** @format int32 */
  transportation?: number;
  /** @format int32 */
  transfer?: number;
  /** @format int32 */
  hotelRooms?: number;
  /** @format int32 */
  hotelRoomsExtraDays?: number;
  /** @format int32 */
  options?: number;
  /** @format int32 */
  originalDiscount?: number;
  /** @format int32 */
  discount?: number;
  discountLabel?: null | string;
  discountType?: TravelDbDiscountTypeEnum;
  /** @format int32 */
  totalPrice?: number;
  /** @format int32 */
  totalPriceWithoutOptions?: number;
}

export interface UserParticipationDocument {
  /** @format int32 */
  id: number;
  /** @format int32 */
  rank?: number;
  type: TravelDbDocumentTypeEnum;
  label: string;
  subTitle?: null | string;
  required: boolean;
  alsoForCompanion?: boolean;
  file?: UserFile;
}

export interface UserParticipationHotelRoom {
  /** @format int32 */
  id: number;
  /** @format int32 */
  rank?: null | number;
  /** @format int32 */
  roomId: number;
  type: TravelDbHotelRoomTypeEnum;
  roommates?: UserParticipationHotelRoommate[];
}

export interface UserParticipationHotelRoommate {
  /** @format int32 */
  userId?: null | number;
  /** @format int32 */
  companionId?: null | number;
  firstName?: null | string;
  lastName?: null | string;
}

export interface UserParticipationInfoField {
  /** @format int32 */
  id: number;
  /** @format int32 */
  rank?: number;
  type: TravelDbFieldTypeEnum;
  label: string;
  required: boolean;
  alsoForCompanion?: boolean;
  choices?: null | string[];
  value?: null | string;
}

export interface UserParticipationInvitation {
  /** @format date-time */
  sentDate?: null | Date;
  /** @format date-time */
  lastUpdateDate?: null | Date;
  /** @format date-time */
  completionDate?: null | Date;
  /** @format date-time */
  refusalDate?: null | Date;
  refusalReason?: null | string;
}

export interface UserParticipationInvoice {
  company?: null | string;
  shopCode?: null | string;
  lastName?: null | string;
  firstName?: null | string;
  address?: null | string;
  zipCode?: null | string;
  city?: null | string;
  country?: null | string;
}

export interface UserParticipationOption {
  /** @format int32 */
  id: number;
  /** @format int32 */
  rank?: number;
  name: string;
  link?: null | string;
  linkLabel?: null | string;
  linkText?: null | string;
  picture?: UserFile;
  activities?: UserParticipationOptionActivity[];
}

export interface UserParticipationOptionActivity {
  /** @format int32 */
  id: number;
  name: string;
  /** @format int32 */
  price: number;
  description?: null | string;
  noPrice: boolean;
  details?: null | string;
  picture?: UserFile;
  /** @format int32 */
  rank?: number;
  /** @format int32 */
  participantCount: number;
}

export interface UserParticipationPayment {
  status: PaymentStatusEnum;
  /** @format int64 */
  amountInCents: number;
}

export interface UserParticipationSignature {
  signingUrl?: null | string;
  /** @format date-time */
  signedDate?: null | Date;
  signedDocument?: UserFile;
}

export interface UserParticipationTransfer {
  /** @format int32 */
  outboundId?: null | number;
  /** @format int32 */
  returnId?: null | number;
  /** @format int32 */
  roundTripId?: null | number;
}

export interface UserParticipationTransportation {
  /** @format int32 */
  id?: null | number;
  /** @format int32 */
  optionId?: null | number;
  /** @format date-time */
  customStartDate?: null | Date;
  /** @format date-time */
  customEndDate?: null | Date;
  outboundCompany?: null | string;
  outboundAirport?: null | string;
  outboundAirportLastStop?: null | string;
  outboundFlightNumber?: null | string;
  /** @format date-time */
  outboundDate?: null | Date;
  /** @format date-span */
  outboundTime?: null | string;
  returnCompany?: null | string;
  returnAirport?: null | string;
  returnAirportLastStop?: null | string;
  /** @format date-time */
  returnDate?: null | Date;
  /** @format date-span */
  returnTime?: null | string;
  returnFlightNumber?: null | string;
}

export interface UserParticipationTravelInfo {
  withPackage?: null | boolean;
  withoutTransport?: null | boolean;
  specialCase?: null | boolean;
  /** @format date-time */
  customStartDate?: null | Date;
  /** @format date-time */
  customEndDate?: null | Date;
  /** @format int32 */
  extraNights?: number;
}

export interface UserParticipationUserInfo {
  /** @format int32 */
  participationId?: number;
  civility?: CivilityEnum;
  status?: UserStatusEnum;
  firstName?: null | string;
  lastName?: null | string;
  email?: null | string;
  mobilePhone?: null | string;
  address?: null | string;
  city?: null | string;
  postalCode?: null | string;
  company?: null | string;
  /** @format date-time */
  birthDate?: null | Date;
  nationality?: null | string;
  passportNumber?: null | string;
  /** @format date-time */
  passportExpirationDate?: null | Date;
  estaNumber?: null | string;
  specialRequests?: null | string;
  allergies?: null | string;
  emergencyContactFirstname?: null | string;
  emergencyContactLastname?: null | string;
  emergencyContactEmail?: null | string;
  emergencyContactPhone?: null | string;
  infoFields?: UserParticipationInfoField[];
}

export interface UserRefusalRequest {
  reason?: null | string;
}

export interface UserSetting {
  key: SettingKeyEnum;
  /** @format int32 */
  rank?: null | number;
  title?: null | string;
  stringValue?: null | string;
  boolValue?: null | boolean;
}

export interface UserTransfer {
  /** @format int32 */
  id: number;
  /** @format int32 */
  rank?: number;
  direction: TravelDbTransferDirectionEnum;
  type: TravelDbTransferTypeEnum;
  name: string;
  /** @format int32 */
  quota: number;
  /** @format int32 */
  quotaLeft: number;
  meetingPoint?: null | string;
  /** @format date-time */
  startDate?: null | Date;
  details?: null | string;
}

export interface UserTransportation {
  /** @format int32 */
  id: number;
  /** @format int32 */
  quota: number;
  /** @format int32 */
  quotaLeft: number;
  /** @format int32 */
  rank?: number;
  type: TravelDbTransportationTypeEnum;
  name: string;
  /** @format int32 */
  extraDays: number;
  outboundCompany?: null | string;
  outboundItinerary?: null | string;
  outboundDate?: null | string;
  returnCompany?: null | string;
  returnItinerary?: null | string;
  returnDate?: null | string;
  options?: null | UserTransportationOption[];
}

export interface UserTransportationOption {
  /** @format int32 */
  id: number;
  /** @format int32 */
  rank?: number;
  name: string;
  /** @format int32 */
  price: number;
  /** @format int32 */
  quota: number;
  /** @format int32 */
  quotaLeft: number;
}

export interface UserTravel {
  /** @format int32 */
  id?: number;
  name: string;
  slug: string;
  type: TravelDbTypeEnum;
  /** @format int32 */
  nights: number;
  /** @format date-time */
  startDate: Date;
  /** @format date-time */
  endDate: Date;
  /** @format date-time */
  registrationEndDate: Date;
  emailContact: string;
  mainPicture?: UserFile;
  logo?: UserFile;
  titleBanner?: UserFile;
  titleBannerAlignment?: TravelDbTitleBannerAlignmentEnum;
  banner?: UserFile;
  roadBook?: UserFile;
  birthDateRequired: boolean;
  passeportRequired: boolean;
  passeportSixMonthsRequired?: null | boolean;
  estaRequired: boolean;
  userStatusRequired: boolean;
  usersStatusAvailable?: null | UserStatusEnum[];
  invoiceEnabled: boolean;
  companionsEnabled: boolean;
  nationalityRequired: boolean;
  addressRequired: boolean;
  emergencyContactRequested: boolean;
  canRefuse?: boolean;
  needRefusalReason?: boolean;
  refusalReasons?: null | string[];
  refusalReasons2?: null | string[];
  infoFields?: null | TravelDbInfoField[];
  transportations?: null | UserTransportation[];
  transfers?: null | UserTransfer[];
  hotels?: null | UserHotel[];
  options?: null | UserOption[];
  pages?: null | UserTravelPageBasic[];
  /** @format int32 */
  packagePrice: number;
  /** @format int32 */
  childPackageCost?: null | number;
  priceTTC: boolean;
  /** @format int32 */
  transportCost: number;
  packageMandatory: boolean;
  paymentEnabled: boolean;
  firmaTemplateId?: null | string;
  isoCode?: null | string;
  refusalLabel?: null | string;
  refusalLongLabel?: null | string;
  buttonPackageSelectionLabel?: null | string;
  companionLabel?: null | string;
}

export interface UserTravelMessages {
  pageInformations?: null | string;
  pageInvoice?: null | string;
  pageCompanions?: null | string;
  pageTransports?: null | string;
  pageTransfers?: null | string;
  pageHotels?: null | string;
  pageOptions?: null | string;
  pageDocuments?: null | string;
  pageRequests?: null | string;
  pagePayment?: null | string;
  pageSummary?: null | string;
}

export interface UserTravelPage {
  /** @format int32 */
  id?: number;
  title?: null | string;
  labelIcon?: null | string;
  content?: null | string;
  hideDuringInscription: boolean;
}

export interface UserTravelPageBasic {
  /** @format int32 */
  id?: number;
  title?: null | string;
  labelIcon?: null | string;
  hideDuringInscription: boolean;
}
